import { FC, useContext } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useMatch } from "react-router-dom";
import { NavLinkType } from "./types";

import { NavigationContext } from "../NavigationContext";
import { IconContainer, StyledLink } from "./styles";
import { useTheme } from "@emotion/react";

type NavLinkProps = {
  navLink: NavLinkType;
};

export const NavLink: FC<NavLinkProps> = ({
  navLink: { name, icon, path, component, noHoverStyling },
}) => {
  const { isSideBarOpen } = useContext(NavigationContext);
  const theme = useTheme();
  const isActive = !!useMatch(path || "");

  return (
    <Box
      fontSize="sm"
      borderRadius="md"
      alignSelf="center"
      position="relative"
      width="100%"
      whiteSpace="nowrap"
    >
      <StyledLink to={path || ""}>
      <Flex alignItems="center" h="48px" marginBottom="8px" position="relative">
        <IconContainer isActive={isActive} className="icon-container">
          {icon}
        </IconContainer>
        <Box
          color={theme.colors.text.onSecondary}
          position="absolute"
          width={isSideBarOpen ? "auto" : 0}
          transform={isSideBarOpen ? "translateX(0)" : "translateX(8px)"}
          transition=".3s"
          left="68px"
        >
          {name}
        </Box>
        {component}
      </Flex>
      </StyledLink>
    </Box>
  );
};
